// @flow
import initialState from './commonInitialState';
import * as types from "../ACTIONS/commonActionTypes";

export default function remoteUserInfoReducer(state = initialState.remoteUserInfo, ourClientId:number, action) {

    switch (action.type) {
        case types.GOT_CURRENT_REMOTE_USER_INFO: {
            const remoteUserInfo = action.currentUser;
            if(remoteUserInfo) {
                return ({
                    initialized: true,
                    name: remoteUserInfo?.name,
                    time: remoteUserInfo?.loginTime,
                    from: remoteUserInfo?.from
                });
            }
            return ({
                initialized: true,
                name: null,
                time: null,
                from: null
            });
        }
        default:
            return(state);
    }
}

